import { Kind } from "graphql";
export function extractVariableNamesFromArguments(args) {
    if (!args) {
        return [];
    }
    const variableNames = [];
    args.forEach((argument)=>{
        if (argument.value.kind === Kind.VARIABLE) {
            variableNames.push(argument.value.name.value);
        }
    });
    return variableNames;
}
export function extractVariableNamesFromTopLevelField(field) {
    const variableNames = [];
    // Extract variables used as arguments to top level field
    variableNames.push(...extractVariableNamesFromArguments(field.arguments));
    // Extract variables used in directive on to top level field
    if (field.directives) {
        field.directives.forEach((directive)=>{
            variableNames.push(...extractVariableNamesFromArguments(directive.arguments));
        });
    }
    return variableNames;
}
export function extractFragmentNamesFromField(field) {
    const fragmentNames = new Set();
    function extractFragments(node) {
        if (node.kind === Kind.FIELD && node.selectionSet) {
            node.selectionSet.selections.forEach((selection)=>{
                if (selection.kind === Kind.FRAGMENT_SPREAD) {
                    fragmentNames.add(selection.name.value);
                } else if (selection.kind === Kind.FIELD) {
                    extractFragments(selection);
                }
            });
        } else if (node.kind === Kind.SELECTION_SET) {
            node.selections.forEach((selection)=>{
                if (selection.kind === Kind.FRAGMENT_SPREAD) {
                    fragmentNames.add(selection.name.value);
                } else if (selection.kind === Kind.FIELD) {
                    extractFragments(selection);
                }
            });
        }
    }
    extractFragments(field);
    return Array.from(fragmentNames);
}

//# sourceMappingURL=field.js.map